const menu = [
  {
    name: '商户',
    path: '/merchant',
    children: [
      {
        name: '食堂管理',
        path: '/merchant/canteen',
      },
      {
        name: '品牌管理',
        path: '/merchant/brand',
      },
      {
        name: '商户管理',
        path: '/merchant/manage',
        children: [
          {
            name: '商户管理',
            path: '/merchant/manage/manage',
          },
        ],
      },
      {
        name: '门店管理',
        path: '/merchant/shop',
        children: [
          {
            name: '门店管理',
            path: '/merchant/shop/manage',
          },
          {
            name: '门店资质',
            path: '/merchant/shop/qualifications',
          },
          {
            name: '门店评分',
            path: '/merchant/shop/score',
          },
        ],
      },
      {
        name: '零食柜管理',
        path: '/merchant/snackcabinet',
      },
      {
        name: '打印模板',
        path: '/merchant/printtemplate',
      },
      {
        name: '计价模板',
        path: '/merchant/valuation',
      },
      {
        name: '客户账号',
        path: '/merchant/customerAccount',
      },
      {
        name: '外部对接',
        path: '/merchant/customerAbutment',
      },
      {
        name: '商户公告',
        path: '/merchant/notice',
      },
      {
        name: '商户指引',
        path: '/merchant/guide',
      },
      {
        name: '星愿',
        path: '/merchant/wish',
        children: [
          {
            name: '星愿管理',
            path: '/merchant/wish/advice',
          },
          {
            name: '助力管理',
            path: '/merchant/wish/assist',
          },
        ],
      },
    ],
  },
  {
    name: '企业',
    path: '/company',
    children: [
      {
        name: '企业管理',
        path: '/company/manage',
        children: [
          {
            name: '企业管理',
            path: '/company/manage/manage',
          },
          {
            name: '合同管理',
            path: '/company/manage/enterprise',
          },
        ],
      },
      {
        name: '福利调账',
        path: '/company/allowance',
      },
      {
        name: '账号处理',
        path: '/company/useraccount',
      },
    ],
  },

  {
    name: '用户',
    path: '/user',
    children: [
      {
        name: '用户信息',
        path: '/user/userinfo',
      },
      {
        name: '用户运营',
        path: '/user/useroperate',
      },
      {
        name: '公告管理',
        path: '/user/notice',
      },

      {
        name: '广告管理',
        path: '/user/advertisement',
      },
      {
        name: '点餐提醒',
        path: '/user/order-remind',
      },
    ],
  },
  {
    name: '订单',
    path: '/order',
    children: [
      {
        name: '外卖订单',
        path: '/order/optorder',
      },
      {
        name: '卡券订单',
        path: '/order/cardorder',
      },
      {
        name: '堂食订单',
        path: '/order/tsorder',
      },
      {
        name: '补单管理',
        path: '/order/supplement',
      },
      {
        name: '活动餐订单',
        path: '/order/activityorder',
      },
      {
        name: '到店付订单',
        path: '/order/shoptopayorder',
      },
      {
        name: '现场打餐统计',
        path: '/order/liveMealStatistics',
      },
      {
        name: '补费订单',
        path: '/order/addOrder',
      },
      {
        name: '售后订单',
        path: '/order/after',
      },
    ],
  },
  {
    name: '商品',
    path: '/goods',
    children: [
      {
        name: '餐单管理',
        path: '/goods/menumanage',
      },
      {
        name: '菜品库',
        path: '/goods/food-library',
      },
      {
        name: '商城商品',
        path: '/goods/welfare',
      },
    ],
  },
  {
    name: '营销',
    path: '/marketing',
    children: [
      {
        name: '营销工具',
        path: '/marketing/tool',
      },
      {
        name: '优惠券',
        path: '/marketing/platform-coupon',
      },
      {
        name: '满减活动',
        path: '/marketing/full-reduction',
      },
      {
        name: '投放管理',
        path: '/marketing/launch-manage',
      },
      // {
      //   name: '物流补贴',
      //   path: '/marketing/logisticssubsidies',
      // },
      {
        name: '返利充值',
        path: '/marketing/often-use',
      },
      {
        name: '返利记录',
        path: '/marketing/money-record',
      },
      {
        name: '返利管理',
        path: '/marketing/record-manage',
      },
      {
        name: '红包活动',
        path: '/marketing/redpacket-manage',
      },
    ],
  },
  {
    name: '评价',
    path: '/advice',
    children: [
      {
        name: '商户评价',
        path: '/advice/comment',
      },
      {
        name: '订单评价',
        path: '/advice/order-comment',
      },
      {
        name: '意见管理',
        path: '/advice/manage',
      },
    ],
  },
  {
    name: '营运',
    path: '/operation',
    children: [
      {
        name: '商圈管理',
        path: '/operation/business',
      },

      {
        name: '取餐组管理',
        path: '/operation/pickmeal',
      },
      {
        name: '取餐点管理',
        path: '/operation/groupaddressmanage',
      },
      {
        name: '投诉管理',
        path: '/operation/complaint',
      },
      {
        name: '大区管理',
        path: '/operation/regionmanage',
        children: [
          {
            name: '大区管理',
            path: '/operation/regionmanage/region',
          },
          {
            name: '区域管理',
            path: '/operation/regionmanage/area',
          },
        ],
      },
      {
        name: '承接人管理',
        path: '/operation/assignee',
      },
      {
        name: '餐柜一键清柜',
        path: '/operation/device',
      },
    ],
  },

  {
    name: '物流',
    path: '/logistics',
    children: [
      {
        name: '首页',
        path: '/logistics/guide',
      },
      {
        name: '配送单元管理',
        path: '/logistics/delivery',
      },
      {
        name: '订单管理',
        path: '/logistics/manage',
        children: [
          {
            name: '物流订单',
            path: '/logistics/manage/gather',
          },
          {
            name: '商家订单',
            path: '/logistics/manage/order',
          },
        ],
      },
      {
        name: '调度管理',
        path: '/logistics/control',
        children: [
          {
            name: '订单调度',
            path: '/logistics/control/dispatch',
          },
          // {
          //   name: '线路规划（旧）',
          //   path: '/logistics/control/route',
          // },
          {
            name: '线路规划（新）',
            path: '/logistics/control/path',
          },
        ],
      },
      {
        name: '站点管理',
        path: '/logistics/source',
        children: [
          {
            name: '中转点管理',
            path: '/logistics/source/transfer',
          },
          {
            name: '门店组管理',
            path: '/logistics/source/businessgroup',
          },
        ],
      },
      {
        name: '人员管理',
        path: '/logistics/receptionist',
      },
      {
        name: '排班管理',
        path: '/logistics/schedule',
      },
      {
        name: '薪酬计提',
        path: '/logistics/accrual',
        children: [
          {
            name: '计提类型',
            path: '/logistics/accrual/type',
          },
          {
            name: '计提规则',
            path: '/logistics/accrual/rule',
          },
        ],
      },
      {
        name: '薪酬管理',
        path: '/logistics/salarymanage',
      },

      {
        name: '时光机',
        path: '/logistics/timeMachine',
      },
      {
        name: '对接管理',
        path: '/logistics/jointmanage',
        children: [
          {
            name: '城市对接',
            path: '/logistics/jointmanage/city',
          },
          {
            name: '品类对接',
            path: '/logistics/jointmanage/category',
          },
        ],
      },
    ],
  },
  {
    name: '数据',
    path: '/data',
    children: [
      {
        name: '总览',
        path: '/data/overview',
      },
      {
        name: '核心数据',
        path: '/data/coredata',
      },
      {
        name: '业务日报',
        path: '/data/daily',
      },
      {
        name: '业绩目标',
        path: '/data/kpi',
      },
      {
        name: '数据导出',
        path: '/data/export',
      },
      {
        name: '数据定义',
        path: '/data/definition',
      },
      {
        name: '管理报表',
        path: '/data/manageReport',
      },
      {
        name: '饭圈报表',
        path: '/data/customergroup',
      },
      {
        name: '指标管理',
        path: '/data/dataNorm',
      },
    ],
  },
  {
    name: '财务',
    path: '/finance',
    children: [
      // {
      //   name: '财务报表',
      //   path: '/finance/speciallist',
      // },
      {
        name: '企业账户管理',
        path: '/finance/monthlyManage',
        children: [
          {
            name: '月结汇总',
            path: '/finance/monthlyManage/monthlySummary',
          },
          {
            name: '授信查询',
            path: '/finance/monthlyManage/creditList',
          },
          {
            name: '充值查询',
            path: '/finance/monthlyManage/stored',
          },
        ],
      },
      {
        name: '资金管理',
        path: '/finance/manage',
        children: [
          {
            name: '资金划拨',
            path: '/finance/manage/capital-divide',
          },
          {
            name: '平台余额管理',
            path: '/finance/manage/balancemanage',
          },
          // {
          //   name: '垫资管理',
          //   path: '/finance/manage/advancefunds',
          // },
          {
            name: '垫资预估管理',
            path: '/finance/manage/advancefundsforecast',
          },
          {
            name: '银行账户管理',
            path: '/finance/manage/account-manage',
          },
          {
            name: '平台银行卡管理',
            path: '/finance/manage/balance',
          },
          {
            name: '小程序充值',
            path: '/finance/manage/physicalcard',
          },
        ],
      },
      {
        name: '调整单',
        path: '/finance/adjustment',
        children: [
          {
            name: '商户调账',
            path: '/finance/adjustment/merchant-reconciliation',
          },
        ],
      },
      {
        name: '账单管理',
        path: '/finance/billmanage',
        children: [
          {
            name: '企业账单',
            path: '/finance/billmanage/billenterprise',
          },
          // {
          //   name: '充值报表',
          //   path: '/finance/billmanage/sheet',
          // },
          {
            name: '企业回款',
            path: '/finance/billmanage/enterprise-collection',
          },
          {
            name: '手动分账',
            path: '/finance/billmanage/manual-split-account',
          },
          {
            name: '企业订单',
            path: '/finance/billmanage/order',
          },
          {
            name: '商家账单',
            path: '/finance/billmanage/merchant',
          },
          {
            name: '平台账单',
            path: '/finance/billmanage/deal-order',
          },
          {
            name: '录入线下成本',
            path: '/finance/billmanage/offline-cost',
          },
        ],
      },
      {
        name: '发票管理',
        path: '/finance/invoice',
      },
      {
        name: '报表管理',
        path: '/finance/manageReport',
        children: [
          {
            name: '收入表',
            path: '/finance/manageReport/income',
          },
          {
            name: '代垫资表',
            path: '/finance/manageReport/payin',
          },
        ],
      },
    ],
  },
  {
    name: '结算',
    path: '/settle',
    children: [
      {
        name: '对账查询',
        path: '/settle/checkbill',
      },
      {
        name: '通道管理',
        path: '/settle/management',
        children: [
          {
            name: '丰食通道配置',
            path: '/settle/management/config',
          },
          {
            name: '丰食通道路由',
            path: '/settle/management/router',
          },
        ],
      },
      {
        name: '结算账户管理',
        path: '/settle/settlement-account-manage',
      },
      {
        name: '结算账户查询',
        path: '/settle/account',
      },
    ],
  },

  // {
  //   name: '配置',
  //   path: '/configure',
  //   children: [
  //     {
  //       name: '消息管理',
  //       path: '/configure/messagemanage',
  //       children: [

  //       ],
  //     },
  //   ],
  // },

  // {
  //   name: '设置',
  //   path: '/settings',
  //   children: [
  //     {
  //       name: '基本信息',
  //       path: '/settings/info',
  //     },
  //     {
  //       name: '授权管理',
  //       path: '/settings/auth',
  //     },
  //   ],
  // },
  {
    name: '商城',
    path: '/shoppingmall',
    children: [
      {
        name: '页面装修',
        path: '/shoppingmall/renovation',
      },
      {
        name: 'banner配置',
        path: '/shoppingmall/banner',
      },
    ],
  },

  {
    name: '合作伙伴',
    path: '/saas-agent',
    children: [
      {
        name: '合作伙伴管理',
        path: '/saas-agent/manage',
      },
      {
        name: '平台管理',
        path: '/saas-agent/platform',
      },
      {
        name: '合作伙伴账单',
        path: '/saas-agent/bill',
      },
    ],
  },
  {
    name: '丰食学堂',
    path: '/school',
    children: [
      {
        name: '管理中心',
        path: '/school/manage',
      },
      {
        name: '课程中心',
        path: '/school/center',
      },
    ],
  },
  {
    name: '硬件',
    path: '/hardware',
    children: [
      {
        name: '硬件管理',
        path: '/hardware/manage',
      },
      {
        name: '设备绑定管理',
        path: '/hardware/binding',
      },
      {
        name: '广告管理',
        path: '/hardware/advertisement',
      },
    ],
  },
  {
    name: '饭圈',
    path: '/chief',
    children: [
      {
        name: '圈长管理',
        path: '/chief/list',
      },
      {
        name: '饭圈管理',
        path: '/chief/customermanage',
      },
      {
        name: '活动管理',
        path: '/chief/activitymanage',
      },
      {
        name: '收益管理',
        path: '/chief/benefitmanage',
      },
      {
        name: '配置中心',
        path: '/chief/configurationcenter',
      },
      {
        name: '企微群管理',
        path: '/chief/chatmanage',
      },
    ],
  },
  {
    name: '环保',
    path: '/environmental',
    children: [
      {
        name: '环保规则配置',
        path: '/environmental/rule',
      },
      {
        name: '商户管理',
        path: '/environmental/shopmanage',
      },
      {
        name: '数据管理',
        path: '/environmental/datamanage',
      },
    ],
  },
  {
    name: '消息',
    path: '/message',
    children: [
      {
        name: '短信绑定',
        path: '/message/template',
      },
      {
        name: '短信管理',
        path: '/message/shortmsg',
      },
      {
        name: '推送记录',
        path: '/message/pushRecord',
      },
      {
        name: '重试配置',
        path: '/message/retryConfiguration',
      },
    ],
  },
  {
    name: '权限',
    path: '/privilege',
    children: [
      {
        name: '菜单绑定',
        path: '/privilege/menu-bind',
      },
      {
        name: '岗位管理',
        path: '/privilege/post-management',
      },
      {
        name: '权限点管理',
        path: '/privilege/auth-point',
      },
      {
        name: '角色管理',
        path: '/privilege/role',
      },
      {
        name: '用户管理',
        path: '/privilege/account',
      },
    ],
  },
  {
    name: '日志',
    path: '/log',
    children: [
      {
        name: '操作日志',
        path: '/log/operation',
      },
    ],
  },
  {
    name: '工具',
    path: '/tool',
    children: [
      {
        name: '组件文档',
        path: '/tool/targetcomponent',
      },
    ],
  },
];

export default menu;
